import React from "react";
import { t } from "../../../components/CustomComponent.js";
import ICON from "../icons.js";
import { PARTNER_STEPS } from "../partner_option.js";

/* ============================================================================
 * PartnerStepper — แถบความคืบหน้าของใบสมัครพาร์ตเนอร์
 *
 * ฟอร์มยาวหลายขั้น ผู้ใช้ต้องเห็นตลอดว่าอยู่ขั้นไหน เหลืออีกกี่ขั้น และขั้นไหน
 * ผ่านไปแล้ว ไม่งั้นจะรู้สึกว่ากรอกไม่จบสักที
 *
 * กดที่ขั้นที่ "ผ่านมาแล้ว" เพื่อย้อนกลับไปแก้ได้ (onJump) แต่กดข้ามไปข้างหน้าไม่ได้
 * เพราะแต่ละขั้นต้องตรวจค่าก่อนถึงจะไปต่อ — ขั้นสุดท้าย (ส่งแล้ว) ล็อกทั้งแถบ
 * ========================================================================== */
export default function PartnerStepper({ current, done = false, onJump }) {
  const index = PARTNER_STEPS.findIndex((step) => step.key === current);

  return (
    <ol className="hm-pt-steps" aria-label={t("partner_progress")}>
      {PARTNER_STEPS.map((step, i) => {
        const passed = i < index;
        const active = i === index;
        // ส่งใบสมัครแล้วห้ามย้อนกลับไปแก้ — ข้อมูลถูกส่งเข้าคิวตรวจสอบไปแล้ว
        const clickable = passed && !done && !!onJump;

        return (
          <li
            key={step.key}
            className={`hm-pt-step ${passed ? "is-passed" : ""} ${active ? "is-active" : ""}`}
            aria-current={active ? "step" : undefined}
          >
            <button
              type="button"
              className="hm-pt-step__btn"
              disabled={!clickable}
              onClick={() => clickable && onJump(step.key)}
            >
              <span className="hm-pt-step__dot">
                {passed ? <span className="hm-ico">{ICON.check}</span> : i + 1}
              </span>
              <span className="hm-pt-step__text">
                <span className="hm-pt-step__label">{t(step.label)}</span>
                <span className="hm-pt-step__desc">{t(step.desc)}</span>
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
